export const PUBLIC_OFFER_ACTIONS_TYPES = {
  SET_TABLE_DATA: 'SET_TABLE_DATA',
  SET_LOADING: 'SIR_LOAD',
  SET_FAILURE: 'SIR_FAILURE',
  SET_PUBLIC_OFFER: 'SET_PUBLIC_OFFER',
  SET_TABLE_SELECTION: 'SET_TABLE_SELECTION',
  SET_DETAIL_LOADING: 'SET_DETAIL_LOADING',
  SET_DETAIL_FAILURE: 'SET_DETAIL_FAILURE',
  SET_PUBLIC_OFFER_STATUS: 'SET_PUBLIC_OFFER_STATUS',
  // SET_EDIT_MODE: 'SET_EDIT_MODE',
}

export const PUBLIC_OFFER_INITIAL_STATE = {
  data: [],
  search: {},
  pagination: {},
  loading: false,
  detailLoading: false,
  detailError: false,
  msLoaded: false,
  error: false,
  publicOffer: {},
  tableSelection: [],
  editMode: false,
}
